import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    // A therapist playing as one of their players, opened from the staff frontend; it brings its own session
    path: 'speel-als',
    loadComponent: () => import('./features/practice/practice.component').then((m) => m.PracticeComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./features/game/game.component').then((m) => m.GameComponent),
  },
];
